'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'circle-sterling';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e5cf';
var svgPathData = 'M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 264c-8.8 0-16-7.2-16-16s7.2-16 16-16l2.9 0c-15.8-55.2 25.5-112 84.7-112l2.2 0c19.7 0 38.8 6.4 54.5 18.2l14.2 10.6c10.6 8 12.8 23 4.8 33.6s-23 12.8-33.6 4.8l-14.2-10.6C284 171 275 168 265.7 168l-2.2 0c-28.5 0-47.8 28.9-37 55.2l2.5 6c.4 .9 .7 1.8 1.1 2.8l73.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-67.1 0c1.3 23.4-5.2 46.9-19.1 66.6l-3.7 5.4 113.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8l30.2-43.1c8.1-11.5 11.6-25.5 10.3-39.1L176 264z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleSterling = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;